const key = 'VEHICLES_';

exports.VEHICLES_TELEMETRY_SUCCESS = `${key}TELEMETRY_SUCCESS`;
exports.VEHICLES_TELEMETRY_LOADING = `${key}TELEMETRY_LOADING`;
exports.VEHICLES_TELEMETRY_ERROR = `${key}TELEMETRY_ERROR`;

exports.VEHICLES_FULL_VEHICLES_SUCCESS = `${key}FULL_VEHICLES_SUCCESS`;
exports.VEHICLES_FULL_VEHICLES_LOADING = `${key}FULL_VEHICLES_LOADING`;
exports.VEHICLES_FULL_VEHICLES_ERROR = `${key}FULL_VEHICLES_ERROR`;
